import pushToDataLayer from './pushToDataLayer';

export interface ClickButtonAnalyticsProps {
	buttonClicked: string;
	contentType: string;
	contentBlock?: string;
	contentName?: string;
	contentId?: string | number;
	caseNumber?: string | number;
	objectTitle?: string;
	objectId?: string | number;
	accessionNumber?: string | number;
}

const trackClickButton = ({
	buttonClicked,
	contentType,
	contentBlock,
	contentName,
	contentId,
	caseNumber,
	objectTitle,
	objectId,
	accessionNumber,
}: ClickButtonAnalyticsProps) => {
	pushToDataLayer({
		event: 'click_button',
		Button_Clicked: buttonClicked,
		Content_Type: contentType,
		...(contentBlock ? { Content_Block: contentBlock } : {}),
		...(contentName ? { Content_Name: contentName } : {}),
		...(contentId !== undefined ? { Content_ID: String(contentId) } : {}),
		...(caseNumber !== undefined ? { Case_Number: String(caseNumber) } : {}),
		...(objectTitle ? { Object_Title: objectTitle } : {}),
		...(objectId !== undefined ? { Object_ID: String(objectId) } : {}),
		...(accessionNumber !== undefined
			? { Accession_Number: String(accessionNumber) }
			: {}),
	});
};

export default trackClickButton;
